const NullHTMLElement: HTMLElement = new Proxy({} as HTMLElement, {
    get() {
        return () => NullHTMLElement;
    },
    set() {
        return true;
    },
}) as HTMLElement;

export const $ = (elementId: string, silent: boolean = false): HTMLElement => {
    var element = document.querySelector(elementId);
    if (element == null) {
        if (!silent) {
            console.warn(`Element ${elementId} not found.`);
        }
        return NullHTMLElement;
    }
    return element as HTMLElement;
};

export const $$ = (elementId: string): HTMLElement[] => {
    const arr: HTMLElement[] = [];
    document.querySelectorAll<HTMLElement>(elementId).forEach((val) => {
        arr.push(val);
    });
    return arr;
};

declare global {
    interface HTMLElement {
        apply<T>(fn: (el: this) => T): this;
    }
}
HTMLElement.prototype.apply = function <T>(
    this: HTMLElement,
    fn: (el: HTMLElement) => T,
): typeof this {
    fn(this);
    return this;
};
